import { shallowEqual } from 'react-redux';
import { format } from 'date-fns';

import { Box } from '@zillow/constellation-10';

import { useSelector } from '../../../selectors/useSelector';
import accessUtils from '../../../utils/accessUtils';

import ListingStat from './ListingStat';
import { statsContainerStyles } from './styles';

const ListingStats = () => {
  const {
    active,
    dateLastActivatedTimestamp,
    expirationDateTimestamp,
    isMultifamily,
    performance: { totalProspectCount, viewCount, isStartDateStartOfTheMonth },
    cookieEnabledServices,
    canAccessZramMultifamilyPropertyTable,
  } = useSelector(
    (state) => ({
      active: state.properties.currentProperty.active,
      dateLastActivatedTimestamp: state.properties.currentProperty.dateLastActivatedTimestamp,
      expirationDateTimestamp: state.properties.currentProperty.expirationDateTimestamp,
      isMultifamily: state.properties.currentProperty.isMultifamily,
      performance: state.properties.currentProperty.performance || {},
      cookieEnabledServices: state.app.cookieEnabledServices,
      canAccessZramMultifamilyPropertyTable: state.user.canAccessZramMultifamilyPropertyTable,
    }),
    shallowEqual,
  );

  const canAccessListingQuality =
    isMultifamily &&
    accessUtils.canAccessListingQuality({
      cookieEnabledServices,
      canAccessZramMultifamilyPropertyTable,
    });

  if (!active && !expirationDateTimestamp) {
    return null;
  }

  const dateTimestamp = Number(!active ? expirationDateTimestamp : dateLastActivatedTimestamp);
  const formattedDate = isNaN(dateTimestamp) ? '-' : format(new Date(dateTimestamp), 'MMM dd yyyy');

  return (
    <Box data-testid="ListingStats" css={statsContainerStyles.raw({ canAccessListingQuality })}>
      {!isMultifamily && <ListingStat title={active ? 'Published' : 'Deactivated'} content={formattedDate} />}

      <ListingStat
        title={`${'Total Prospects'}${isStartDateStartOfTheMonth ? ' this month' : ''}`}
        content={totalProspectCount || '-'}
      />

      <ListingStat title={`Views${isStartDateStartOfTheMonth ? ' this month' : ''}`} content={viewCount || '-'} />
    </Box>
  );
};

export default ListingStats;
